<div class=" scrollable-x">
    <table mat-table [dataSource]="dataSource" >
        <ng-container *ngFor="let key of columns" [matColumnDef]="key">
            <th mat-header-cell *matHeaderCellDef>{{ getLabel(key) }}</th>
            <td mat-cell *matCellDef="let element">{{ formatValue(element[key], key) }}</td>
        </ng-container>


        <ng-container matColumnDef="action" >
            <th mat-header-cell *matHeaderCellDef> {{ 'ITEM.ACTION' | translate
                }} </th>
            <td mat-cell *matCellDef="let element">
<!--
                <button mat-icon-button color="primary"
                    [routerLink]="['/apikeys', element.apiKey]"
                    matTooltip="{{ 'BUTTON.DELETE' | translate }}">
                    <mat-icon inline>edit</mat-icon>
                </button>
-->
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="columns"></tr>
        <tr mat-row *matRowDef="let row; columns: columns;"></tr>
    </table>
    <ng-content></ng-content>
</div>